module.exports = __webpack_public_path__ + "static/media/Yosemite.722a18ae.jpg";